import { InjectionToken } from '@angular/core';
import { EnvVars } from './env-vars.model';

export const ENV: InjectionToken<EnvVars> = new InjectionToken('Environment variables as a token');
